export const Status_Data ={
    Failed:"Failed",
    Rejected:"Rejected",
    Open:"Open",
    InProgress:"In Progress",
    Pending:"Pending",
    Closed:"Closed",
    Approved:"Approved",
    Total:"Total"
}

export const Status_BG_Data= {
    Failed: 'bg-red',
    Rejected: 'bg-red',
    Open: 'bg-blue',
    InProgress: 'bg-orange',
    Pending: 'bg-orange',
    Closed: 'bg-green',
    Approved: 'bg-green',
    Total: 'bg-blue-gray',
}

export const Table_View= {
    Grid:"Grid",
    List:"List"
}

export const Selected_Index ={
    i_Zero: "0",
    i_One: "1",
    i_Two: "2",
    i_Three: "3"
}

export const Header_Filter_Button_Label= {
    AddCostCode: "Add Cost Center",
    AddGlCode: "Add GL Code",
    AddAccount: "Add Account",
    AddContract: "Add Contract",
    AddDispute: "Add Dispute",
    AddPlan: "Add Plan",
    AddFeature: "Add Feature",
    AddRate: "Add Rate",
    AddUserAccess: "Add User Access",
    AddUserRole: "Add User Role",
    AddNewVendor: "Add New Vendor"
}